/**
 * Static decoration mark for ::render syntax (L2 mode).
 */

import { Decoration } from "@codemirror/view";

export const renderMark = Decoration.mark({ class: "cm-magic-render" });
